import { Avatar, IconButton, Typography } from "@mui/material";
import { FC } from 'react';

import { MerchantInfoProps } from "./interfaces";

const MerchantInfo: FC<MerchantInfoProps> = ({ userInfo, merchantInfo }: MerchantInfoProps) => {
  return (
    <>
      <Typography
        component={'div'}
        sx={{
          flexGrow: 1,
          fontSize: '1.25rem',
          fontWeight: '400',
        }}
      >
        Merchant ID: {merchantInfo?.merchant_id}
      </Typography>
    </>
  );
};

export default MerchantInfo;